import SystemPage from "@/components/feature/SystemPage";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SystemPage
        code="404"
        icon="ri-compass-3-line"
        title="Page introuvable"
        description="La page que vous recherchez n'existe pas ou a été déplacée. Vérifiez l'adresse ou revenez à l'accueil."
        primaryLabel="Retour à l'accueil"
        primaryTo="/"
        secondaryLabel="Voir les tarifs"
        secondaryTo="/tarifs"
      />
    </div>
  );
}